import React, {
  useEffect,
  useState,
} from 'react';

import { classesAPI } from 'api/classesAPI';
import {
    cloneDeep,
    isEmpty, uniq,
} from 'lodash';
import { Line } from 'rc-progress';
import { useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { selectedMenu } from 'state';
import styled from 'styled-components';

import profile from '../../../../../assets/images/banner.png';
import PenImg from '../../../../../assets/images/pen.png';
import { dateUtil } from '../../../../../util';
import {DropdownMenu, Pagenation} from "../../../../components";
import {fadeIn} from "../../../../../styled/StyledComponent";
import {commonAPI} from "../../../../../api/commonAPI";
import EmptyBox from "../../../../components/common/EmptyBox";
import EditIcon from "../../../../../assets/images/icon/EditIcon";

interface StyledComponentProps {
    width?: string;
    display?: string;
}

const Published = () => {
    const menu = useRecoilValue(selectedMenu);
    const navigate = useNavigate();
    const [list, setList] = useState([]);
    const [categoryParams, setCategoryParams] = useState(    {
        dropdownItem:"All",
        display:"All",
        params:""
    },);
    const [pageInfo, setPageInfo] = useState({
        totalPages: 0,
        number: 0,
        size: 5,
    });
    const [uploadData, setUploadData] = useState({
        category: "",
        subCategory: "",
    });

    const onClickMovePage = (isNext) => {
        const c = cloneDeep(pageInfo);
        if (isNext) {
            if (pageInfo?.number + 1 === pageInfo?.totalPages) return;
            c.number = c.number + 1;
        } else {
            if (pageInfo?.number === 0) return;
            c.number = c.number - 1;
        }
        setPageInfo(c);
    };
    const getClassItem = async () => {
        const result = await classesAPI
            .getAdminClassList({
                params:{
                    progress:"PUBLISHED",
                    size: 5,
                    page: pageInfo?.number,
                    category:uploadData.category == "All" ? "" : uploadData.category,
                    subCategory:uploadData.category == "All" ? "" : uploadData.subCategory
                }
                
            })
            .then((res) => {
                setList(cloneDeep(res?.data?.content))
                setPageInfo({
                    ...pageInfo,
                    totalPages:res?.data?.totalPages,
                    number:res?.data?.number,
                    // size:res?.size
                })
            });
        return result;
    };

    const gotoCreateStep = (id:any) => {
        navigate('/create/details',{
            state:{
                createId:id
            }
        })
    };


    const [data, setData] = useState(null);

    const getCategory = async () => {
        const result = await commonAPI.getCategory(null).then((res) => {

            return res?.data;
        });

        if (!isEmpty(result)) {
            const data = result?.map((item: any) => item.category);
            const category = uniq([...data]);
            setData( { category: [ "All",...category], categoryData: result });
        }
        console.log("result", result);
    };

    const getSubCategory = (category: string): { subCategory: any; subCategoryDataArray: any } => {
        if (isEmpty(data)) return null;
        const subCategory = data?.categoryData
            ?.filter((item: any) => {
                return item?.category === category;
            })
            .map((item: any) => {
                return {
                    ...item,
                    dropdownItem: item?.subCategory,
                };
            });
        console.log('subCategoryDataArray', subCategory)
        return {
            subCategory: subCategory[0]?.subCategory || "",
            subCategoryDataArray: subCategory,
        };
    };

    useEffect(() => {
        getCategory()
    }, []);

    useEffect(()=>{
        setUploadData({
            ...uploadData,
            subCategory:getSubCategory(uploadData?.category)?.subCategory || "",
        })
    },[uploadData?.category]);

    const onClickDropdown = (item: any, key: string, index, obj) => {
        let selectItem;
        console.log('obj', obj)
        if(!isEmpty(obj)){
            const copy = cloneDeep(obj);
            delete copy.dropdownItem;
            selectItem = copy;
        }else{
            selectItem = item
        }
        console.log('selectItem', selectItem)
        setUploadData({
            ...uploadData,
            [key]:selectItem,
        });
    };
    useEffect(() => {
        getClassItem();
    }, [pageInfo.number, uploadData.subCategory]);

    return (
        <Container>
            <ContentsInner>
                <MainHeader>
                    <Row display={"flex"}>
                        <Col>
                            <FormBox>
                                <dd>
                                    <FormBoxItemWrap>
                                        <li>
                                            <FormItem>
                                                <DropdownMenu
                                                    altText={"Select category"}
                                                    selected={uploadData?.category}
                                                    items={data?.category || []}
                                                    state={"category"}
                                                    onClick={onClickDropdown}
                                                    height={40}
                                                />
                                            </FormItem>
                                        </li>
                                    </FormBoxItemWrap>
                                </dd>
                            </FormBox>
                        </Col>
                        <Col
                            className={"category2"}
                        >
                            <FormBox
                                // style={{opacity: uploadData?.category == "" ? 0.4 : 1 }}
                            >
                                <dd>
                                    <FormBoxItemWrap>
                                        <li>
                                            <FormItem
                                                style={{
                                                    pointerEvents:
                                                        uploadData?.category == ""
                                                            ? "none"
                                                            : "all",
                                                }}
                                            >
                                                <DropdownMenu
                                                    selected={uploadData?.subCategory}
                                                    state={"subCategory"}
                                                    altText={"Select sub category"}
                                                    onClick={onClickDropdown}
                                                    height={40}
                                                    items={
                                                        getSubCategory(uploadData?.category)
                                                            ?.subCategoryDataArray?.map(arrItem => {
                                                            return arrItem?.subCategory
                                                        }) || []
                                                    }
                                                    // obj
                                                    // items={
                                                    //     getSubCategory(uploadData?.category)
                                                    //         ?.subCategoryDataArray || []
                                                    // }
                                                />
                                            </FormItem>
                                        </li>
                                    </FormBoxItemWrap>
                                </dd>
                            </FormBox>
                        </Col>
                    </Row>
                </MainHeader>
                <Wrap>
                    {!isEmpty(list) &&
                        list?.map((item: any) => {
                            return (
                                <ListItem>
                                    <Thumb>
                                        <img src={item?.thumbnailUrl || profile} alt="" />
                                    </Thumb>
                                    <ListMain>
                                        <Category
                                            style={{
                                                background:"#A2BFFE",
                                                color:"#333"
                                            }}
                                        >
                                            <span>
                                                {/* {(
                                                    item?.progress?.charAt(0).toUpperCase() +
                                                    item?.progress?.slice(1).toLowerCase()
                                                ).replace("_", " ")} */}
                                                Published
                                            </span>
                                        </Category>
                                        <h3>{item?.classTitle}</h3>
                                        <DateItem>
                                            <span>
                                                {dateUtil.mainCardDateFormat(item.updatedDatetime)}
                                            </span>
                                        </DateItem>
                                        {/*<Progress>*/}
                                        {/*    <span>*/}
                                        {/*        <b>78</b>&nbsp;/&nbsp;100*/}
                                        {/*    </span>*/}
                                        {/*    <ProgressBar>*/}
                                        {/*        <Line*/}
                                        {/*            percent={70}*/}
                                        {/*            trailWidth={0.7}*/}
                                        {/*            style={{*/}
                                        {/*                border: "solid 1px #e9ecef",*/}
                                        {/*                borderRadius: 4,*/}
                                        {/*            }}*/}
                                        {/*            trailColor={"#fff"}*/}
                                        {/*            strokeWidth={0.7}*/}
                                        {/*            strokeColor="#ddc160"*/}
                                        {/*        />*/}
                                        {/*    </ProgressBar>*/}
                                        {/*</Progress>*/}
                                    </ListMain>
                                    <ListButton onClick={()=>{gotoCreateStep(item?.id)}}>
                                        <span>Edit</span>
                                        <EditIcon/>
                                    </ListButton>
                                </ListItem>
                            );
                        })}
                        {
                            isEmpty(list) &&
                            <EmptyBox url={"/images/nothing.png"} />
                        }
                </Wrap>
            </ContentsInner>
            <Pagenation
                totalPage={pageInfo?.totalPages}
                onClickMove={(isNext) => {
                    onClickMovePage(isNext);
                }}
                size={pageInfo?.size}
                pageNumber={pageInfo?.number}
            />
        </Container>
    );
};
export default Published;

const Container = styled.div`
    height: 100%;
    animation: ${fadeIn} 0.3s linear; /* fadeIn keyframe을 사용하여 애니메이션 적용 */
`;
const MainHeader = styled.div``;
const ContentsInner = styled.div`
    padding: 20px;
    overflow: hidden;
    min-height: 400px;
`;

const Wrap = styled.div`
    scrollbar-width: thin;
    scrollbar-color: transparent transparent;
    scroll-behavior: smooth;
    &::-webkit-scrollbar {
        width: 0;
    }

    &::-webkit-scrollbar-thumb {
        background-color: transparent;
    }
`;

const ListItem = styled.div`
    display: flex;
    position: relative;
    padding: 20px 0;
    border-top: 1px solid rgba(51, 51, 51, 0.3);
    
`;
const Thumb = styled.div`
    background: #ddd;
    overflow: hidden;
    width: 113px;
    height: 113px;
    border-radius: 5px;
    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
`;
const ListMain = styled.div`
    padding: 0 20px;
    flex: 1;
    h3 {
        font-size: 26px;
        margin: 8px 0 9.6px 0;
    }
`;
const Category = styled.div`
    padding: 7px 12px;
    background: #f0a8a8;
    width: 85px;
    font-size: 12px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    margin-bottom: 4px;
    span {
        text-transform: capitalize;
        font-weight: 700;
    }
`;
const DateItem = styled.div`
    span {
        font-family: "Source Serif 4", sans-serif;
        color: #333333;
        font-size: 14px;
        font-weight: 600;
        line-height: 14px;
        letter-spacing: 0em;
        text-align: left;
        opacity: 0.5;
    }
`;
const Row = styled.div<StyledComponentProps>`                               
    display: ${(props) => props.display};                                   
    justify-content: space-between;                                         
    margin-bottom: 10px;                                                    
    width: 50%;                                                             
    @media screen and (max-width: 768px) {                                  
        flex-direction: column;                                             
        width: 100%;                                                        
        & > div{                                                            
            width: 100%;                                                    
        }                                                                   
    }                                                                       
`;
const Col = styled.div<StyledComponentProps>`                           
    width: calc((100% - 18px) / 2);                                     
    @media screen and (max-width: 768px) {                              
        &.selectLevel{                                                  
            margin-top: 15px;                                           
        }                                                               
        &.category2{                                                    
            margin-top: 15px;                                           
        }                                                               
        &.promotionalVideo{                                             
            margin-top: 15px;                                           
        }                                                               
    }                                                                   
`;
const FormBox = styled.dl`                                          
    > dt {                                                          
        font-size: 16px;                                            
        font-weight: 400;                                           
        color: #333;                                                
        line-height: 24px;                                          
        letter-spacing: 0em;                                        
        text-align: left;                                           
        > strong {                                                  
            font-size: 13px;                                        
            font-weight: 600;                                       
            color: #da1414;                                         
            display: inline-block;                                  
            margin-left: 1px;                                       
            vertical-align: top;                                    
        }                                                           
    }                                                               
`;
const FormBoxItemWrap = styled.ul`
    > li {
        font-size: 16px;
        margin: 8px 0 0 0;
    }
`;
const FormItem = styled.div`                                    
    position: relative;                                         
    .topics {                                                   
        z-index: 9999;                                          
    }                                                           
    .keywords {                                                 
        z-index: 999;                                           
    }                                                           
    input{                                                      
        height: 40px!important;                                 
    }                                                           
    input[type="text"],                                         
    select,                                                     
    textarea {                                                  
        height: 40px;                                           
        width: 100%;                                            
        font-family: Europa-Regular;                            
        font-size: 16px;                                        
        outline: none;                                          
        border-radius: 8px;                                     
        border: solid 1px rgba(51, 51, 51, 0.3);                
        padding: 12px 16px;                                     
        &::placeholder {                                        
            color: #ddd;                                        
        }                                                       
    }                                                           
    > input[type="text"] {                                      
        height: 40px;                                           
    }                                                           
    > select {                                                  
        height: 40px;                                           
        -webkit-appearance: none;                               
        appearance: none;                                       
    }                                                           
`;
const Progress = styled.div`
    font-size: 14px;
    font-weight: 700;
    line-height: 14px;
    letter-spacing: 0em;
    color: rgba(51, 51, 51, 0.6);
    text-align: end;
    margin-bottom: 0.25rem;
    max-width: 500px;
    b {
        color: #333;
    }
`;
const ProgressBar = styled.div``;
const ListButton = styled.div`
    border: solid 1px #333;
    &:hover{
        background: #fff;
        span{
            color: #333;
        }
        svg{
            display: block;
            path{
                fill: #333!important;
            }
        }
    }
    svg{
        display: block;
        path{
            fill: #fff;
        }
    }
    transition: all 0.2s;
    background: #333;
    width: 80px;
    height: 30px;
    border-radius: 5px;
    overflow: hidden;
    padding: 0 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    span {
        display: flex;
        height: 100%;
        align-items: center;
        color: #fff;
        box-shadow: none;
        border-radius: 5px;
        font-family: var(--fontFamilyRegular);
        font-size: 12px;
        font-weight: 400;
        line-height: 12px;
    }
`;
